import React, {Component, Fragment} from "react";
import {Button, Col, Input, Row, Table} from "reactstrap";
import {EventClient} from "../../../util/eventClient";
import {postData} from "../../../api/doLogin";

export class UserPolicyLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      active: true,
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {}
    };

  }

  onAdd() {
    const [table, id] = this.state.addChosen.split("_");
    if (table && id) {
      postData(`admin/users/${this.props.user.id}/policyadd`, {table, id})
        .then((data) => {
          // console.log(data);
          if (data.status === "Success") {
            this.props.onAdd && this.props.onAdd(table, id);
            this.setState({showAdd: false, addChosen: ""});
          } else {
            EventClient.emit("TOAST_ERROR", data.message);
          }
        })
        .catch((err) => {
          EventClient.emit("TOAST_ERROR", error.message);
          console.log(err);
        });

    } else {
      this.setState({showAdd: false, addChosen: ""});
    }
  }

  onRemove(table, id) {
    postData(`admin/users/${this.props.user.id}/policyremove`, {table, id})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          this.props.onRemove && this.props.onRemove(table, id);
          this.setState({showAdd: false, addChosen: ""});
        } else {
          EventClient.emit("TOAST_ERROR", data.message);
        }
      })
      .catch((err) => {
        EventClient.emit("TOAST_ERROR", error.message);
        console.log(err);
      });
  }

  render() {

    const addOptions = this.props.policies.filter(pol => pol.enabled !== 1);
    const tdStyle = {padding: "unset", verticalAlign: "middle"};
    return (
      <Fragment>
        <div>*Changes take effect immediately</div>
        <Table>
          <thead>
          <tr>
            <td>Level</td>
            <td>Display</td>
            <td>Action</td>
          </tr>
          </thead>
          <tbody>
          {this.props.policies.filter((user) => !!user.enabled).map((user, index) => {
            return (<tr key={index}>
              <td style={tdStyle}>{user.table}</td>
              <td style={tdStyle}>{user.display}&nbsp;({user.id})</td>
              <td style={tdStyle}><Button onClick={() => this.onRemove(user.table, user.id)}>Remove</Button></td>
            </tr>)
          })}
          </tbody>
          <tfoot>
          <tr>
            <td colSpan={3}>
              {!this.state.showAdd ?
                <Button onClick={() => this.setState({showAdd: true})}>Add</Button>
                :
                <Fragment>
                  <Row>
                    <Col xs={12} md={6}>
                      <Input type={"select"}
                             defaultValue={""}
                             onChange={(event) => {
                               this.setState({addChosen: event.target.value});
                             }}
                      >
                        <option value={""} disabled={true}>Select...</option>
                        {addOptions.map((option, index) => {
                          return <option key={index}
                                         value={`${option.table}_${option.id}`}>{`${option.table} > ${option.display} (${option.id})`}</option>
                        })}
                      </Input>
                    </Col>
                    <Col xs={12} md={6}>
                      <Button onClick={() => this.onAdd()}>Add</Button>
                      <Button onClick={() => this.setState({showAdd: false, addChosen: ""})}>Cancel</Button>
                    </Col>
                  </Row>
                </Fragment>
              }
            </td>
          </tr>
          </tfoot>
        </Table>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Admin/Users/UserPolicyLink.js